import deliveryCar from '../../img/dispatch.png';
import styles from './DispatchMessage.module.css'
import  {useState, useEffect } from "react";

export function DispatchMessage() {
    const date = new Date();
    const dispatchDate = `${date.toISOString().split('T')[0]}T15:00`
    const [time, setTime] = useState(1);
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);

    useEffect(() => {
        getTimeDifference(dispatchDate);
        const interval = setInterval(() => getTimeDifference(dispatchDate), 1000);
        return () => clearInterval(interval);
    }, [dispatchDate]);

    const getTimeDifference = (dispatchDate) => {
        const time = Date.parse(dispatchDate) - Date.parse(new Date());
        const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((time / 1000 / 60) % 60);
        setTime(time);
        setHours(hours);
        setMinutes(minutes);
    };

    return (
        <>
            { time > 60000 && date.getDay() !== 6 && date.getDay() !== 0 && <div className={styles['dispatch-message'] + " flex items-center"}>
                    <div className={styles['dispatch-message__image'] + " flex items-center" }>
                        <img width="69" height="35" src={deliveryCar} alt="delivery car"/>
                    </div>
                    <h4>
                    Want your plates dispatched today? 
                    <strong>
                         Order within <span className="clock">
                            {hours}{hours === 1 ? 'hr ' : 'hrs '}
                        </span>
                        <span className="clock">
                            {minutes}{minutes === 1 ? 'min ' : 'mins ' }
                        </span>
                    </strong>
                    </h4>
                </div>
            }
        
        </>

    );
}


